//task :  https://www.notion.so/cognni/Partners-Portal-Metrics-Datasource-ab8ab64b28ad4ae49400740120dc7735

import { LoggedUser } from "./common/models";
import axios from "axios";
import { SharedState } from "./common/state";
import { throttle_arr_exec } from "./fp";

type AppComponentName =
  | "Upgrade"
  | "General"
  | "Apps"
  | "Apps-directory"
  | "Settings"
  | "Mapping"
  | "Detection"
  | "Investigation"
  | "Onboarding"
  | "Admins"
  | "Accounts";

interface AnalyticsEvent {
  // organization unique identifier
  orgId: string;
  partnerId: string;
  // component unique name
  component: string;
  // user email address
  email: string;
  EmailAddress: string;
  // event unique name
  eventId: string;
  // event time (ISO Timestamp)
  eventTime: string;
  // array of unique tag names
  tags: string[];
  // simple object contains additional properties
  data: { [key: string]: any };
}

export const AppAnalytics = (() => {
  let isActive = true;
  const authorization =
    "Basic NWM4MDE2NTItZjZhOS00NjdlLTk5NjgtNmZmNjUxMWRlYWEyOiYxPGhiXVZCYHZVTypgRHo8bXQrWWsrJjc5VGxZWWQwJD0qb0JmaUktZXpXUFRbNEAxaG5oR2RfJ1VeIUtOWg==";
  let email: string;
  let orgId: string;
  let partnerId: string;
  let baseUrl: string;

  // user.authorization is updated during the app so
  // I want it fresh when I need to send data to the server
  const _getUser = (): LoggedUser => SharedState.loggedUser.value;
  let _env = "";

  const _initData = () => {
    if (!baseUrl) {
      const { analytics, env } = SharedState.env.value;
      baseUrl = analytics;
      _env = env;
    }
    if (!email) {
      const user = _getUser();
      email = user.email;
      orgId = user.orgName;
      partnerId = user.partnerId;
    }
  };

  const report_api = async (arr: AnalyticsEvent[]) => {
    _initData();
    if (arr.length === 0) {
      return;
    }
    try {
      axios({
        method: "POST",
        baseURL: baseUrl,
        url: `/events/front`,
        data: [...arr],
        headers: {
          authorization: authorization,
        },
      });
    } catch (error) {
      console.log("error sending analytics", error);
    }
  };

  const events = throttle_arr_exec<AnalyticsEvent>(2000, 10)(report_api);

  const _onBoardingReport = (eventName: string) => {
    _initData();
    try {
      axios({
        method: "POST",
        baseURL: baseUrl,
        url: `/events/onboarding`,
        data: {
          orgId: orgId,
          email: email,
          Emailaddress: email,
          eventId: eventName,
          tags: [],
          data: {},
        },
        headers: {
          authorization: authorization,
        },
      });
    } catch (error) {
      console.log("error sending analytics", error);
    }
  };

  /* public api */

  const report = (p: {
    component: AppComponentName;
    eventName: string;
    payload?: any;
  }) => {
    const { component, eventName, payload = {} } = p;
    _initData();
    if (_env === "local" || !isActive) {
      console.log(
        "%c",
        `<p style="color:pink">would have report to analytics about :  <b>${eventName}</b> if this wasn't local</p>`
      );
      return;
    }
    if (component === "Onboarding") {
      _onBoardingReport(eventName);
    } else {
      events.add({
        component,
        email,
        EmailAddress: email,
        partnerId,
        orgId,
        eventId: eventName,
        eventTime: new Date().toISOString(),
        tags: [],
        data: payload,
      });
    }
  };

  const stop = () => {
    isActive = false;
  };

  return {
    report,
    stop,
  };
})();
